<div class="card" *ngIf="!!files">
  <div class="card-header">
    Dokumente
  </div>
  <div class="card-block">
    <clr-datagrid [clrDgLoading]="loading">
      <clr-dg-column [clrDgField]="'fileName'">Datei</clr-dg-column>
      <clr-dg-column [clrDgField]="'description'">Dateibeschreibung</clr-dg-column>
      <clr-dg-column>Hochgeladen am</clr-dg-column>
      <clr-dg-column></clr-dg-column>

      <clr-dg-placeholder>Aktuell keine Dateien gefunden!</clr-dg-placeholder>

      <clr-dg-row *clrDgItems="let filesB of files" [clrDgItem]="filesB">
        <clr-dg-action-overflow>
          <button class="action-item" *ngIf="filesB.fileType === 'application/pdf'" (click)="showModal(filesB.id)">Show PDF</button>
          <button class="action-item" (click)="loadFile(filesB.id, filesB.fileName)">Download</button>
        </clr-dg-action-overflow>
        <clr-dg-cell>{{ filesB.fileName }}</clr-dg-cell>
        <clr-dg-cell>{{ filesB.description }}</clr-dg-cell>
        <clr-dg-cell>{{ filesB.time }}</clr-dg-cell>
        <clr-dg-cell>
          <cds-icon shape="times-circle" class="is-solid" (click)="deleteFile(filesB.id, filesB.fileName)"></cds-icon>
        </clr-dg-cell>
      </clr-dg-row>
    </clr-datagrid>
  </div>
  <div class="card-footer">
    <button *ngIf="companyId" class="btn btn-sm btn-link"  (click)="showFileUploader()">Dokument hinzufügen</button>
  </div>
</div>


<ng-container *ngIf="showPDF">
  <clr-modal id="pdfViewer" [(clrModalOpen)]="showPDF" [clrModalStaticBackdrop]="false">
    <h3 class="modal-title">{{ modalContent }}</h3>
    <div class="modal-body">
      <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
    </div>
  </clr-modal>
</ng-container>

<ng-container *ngIf="showFileUpload">
  <clr-modal id="fileUploader" [(clrModalOpen)]="showFileUpload" [clrModalStaticBackdrop]="false">

    <h3 class="modal-title">Dokument zur Firma {{ companyId }} ablegen?</h3>
    <div class="modal-body">
      <app-upload [companyId]="companyId" [componentId]="'0'" [projectId]="'0'" [jobId]=0 [subId]=0 [docType]=8 (closeModalEvent)="closeModal($event)"></app-upload>
    </div>

  </clr-modal>
</ng-container>
